import { Component, EventEmitter, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { PackageService } from 'src/app/private/services/package.service';

@Component({
  selector: 'app-package-list',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './package-list.component.html',
  styleUrl: './package-list.component.scss'
})
export class PackageListComponent {
  @Output() editPackage = new EventEmitter<any>();
  @Output() deletePackage = new EventEmitter<any>();
  @Output() openPackageForm = new EventEmitter<any>();
  
  
  packages: any[] = [];
  loading = false;
  totalRecords = 0;
  searchText = '';

  constructor(
    private packageService: PackageService,
    private messageService: MessageService
  ) {}

  openCreatePackage(){
    this.openPackageForm.emit()
  }
  ngOnInit() {
    this.loadPackages();
  }

  loadPackages() {
    this.loading = true;
    const data = {
      page: 0,
      limit: 10000,
      where: {},
      order: {
        col: '\"package\".\"updatedAt\"',
        dir: 'DESC'
      }
    };

    this.packageService.getAllPackage(data).subscribe({
      next: (res: any) => {
        console.log("ressss",res);
        this.packages = res.rows || [];
        this.totalRecords = res.count || 0;
        this.loading = false;
      },
      error: (err) => {
        console.error('Failed to fetch packages:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load packages'
        });
        this.loading = false;
      }
    });
  }

  onEdit(pkg: any) {
    this.editPackage.emit(pkg);
  }

  onDelete(pkg: any) {
    this.deletePackage.emit(pkg);
  }

  filterPackages() {
    return this.packages.filter(pkg => 
      !this.searchText || 
      pkg.package_name.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  // "features": {
  //       "limits": [
  //         {
  //           "key": "total_leads",
  //           "value": 1000,
  //           "enabled": true,
  //           "isLimit": true
  //         }
  //       ],
  //       "features": [
  //         {
  //           "key": "analytics_basic",
  //           "enabled": true,
  //           "isLimit": false
  //         }
  //       ]
  //     },

  getFeaturesSummary(packageFeatures: any[]): string {
    // if (!packageFeatures || packageFeatures.length === 0) return 'No features';
    // const limits = packageFeatures.filter((f: any) => f.isLimit || f.limit);
    // if (limits.length === 0) return `${packageFeatures.length} features`;
    // return limits.map((f: any) => `${f.key}: ${f.value || f.limit}`).join(', ');


    // feature will be either array or object
    if (!packageFeatures) return 'No features';

    const featuresArray = Array.isArray(packageFeatures) ? packageFeatures : Object.values(packageFeatures);

    const limits = featuresArray.filter((f: any) => f.isLimit);
    if (limits.length === 0) return `${featuresArray.length} features`;
    return limits.map((f: any) => `${f.key}: ${f.value || f.limit}`).join(', ');
  }


  getPrice(pkg: any): number {
    if(pkg?.price?.base != null) {
      return pkg.price.base;
    }else if(pkg?.price != null) {
      return pkg.price;
    }else{
      return 0;
    }
  }
}
